import React from "react";

// Icons
import bin from "../../../../../assets/icons/bin.svg";
import edit from "../../../../../assets/icons/edit_grey.svg";

//Style
import "./CustomField.scss";

const CustomField = ({ field, viewOnly, children, handleEditField, deleteFieldFromSection }) => {
  const handleEdit = () => {
    handleEditField(field.fieldId);
  };
  const handleDelete = () => {
    deleteFieldFromSection(field);
  };
  return (
    <div className="d-flex flex-row custom-field align-items-top">
      {children}
      {field?.mode === "Created" && !viewOnly ? (
        <div className="custom-field-actions">
          <img className="edit" src={edit} alt="edit" onClick={handleEdit} />
          <img className="delete" src={bin} alt="delete" onClick={handleDelete} />
        </div>
      ) : null}
    </div>
  );
};

export default CustomField;
